<script lang="ts">
    import LayerComponent from "./Layer.svelte";
    import { _ } from "svelte-i18n";
    import type { LayersManager } from "./LayersManager";

    export let manager: LayersManager;
    let layers = manager.getLayerManagersStore();
    let destination = manager.getDestinationTrafficStore();
    let through = manager.getThroughTrafficStore();
</script>

<div class="box">
    <h6 class="box-header mx-0 px-1 text-muted">
        <div class="row mx-0">
            {$_("impact.scenario.tipsMatrixModal.explanation")}
        </div>
        <div class="row mx-0">
            <label class="px-0">
                <input bind:checked={$destination} type="checkbox" />
                {$_("impact.scenario.tipsMatrixModal.destination")}
            </label>
        </div>
        <div class="row mx-0">
            <label class="px-0">
                <input bind:checked={$through} type="checkbox" />
                {$_("impact.scenario.tipsMatrixModal.through")}
            </label>
        </div>
    </h6>
    <div class="box-content">
        {#if $layers.length == 0}
            <p class="text-center text-muted">
                {$_("impact.scenario.tipsMatrixModal.noLayers")}
            </p>
        {:else}
            <ul class="list-group px-1 mb-1">
                {#each $layers as layer}
                    <LayerComponent bind:manager={layer} />
                {/each}
            </ul>
        {/if}
    </div>
</div>

<style>
    .list-group {
        border-radius: 0.375rem;
        display: flex;
        flex-direction: column;
    }

    .box {
        display: flex;
        flex-flow: column;
        height: 100%;
        max-height: 100%;
    }

    .box .box-header {
        flex: 0 0 auto;
    }

    .box .box-content {
        flex: 1;
        overflow: auto;
    }
</style>
